/** Must match server/powersync-backend .../slackNotificationChannels/workflows.ts */
export const slackNotificationWorkflowChoices = [
  { id: 'data-export-notification', name: 'data-export-notification' },
  { id: 'data-processing-alert', name: 'data-processing-alert' },
  { id: 'cert-ops-alert', name: 'cert-ops-alert' },
  { id: 'cert-ops-exhausted', name: 'cert-ops-exhausted' },
] as const;
